import { formatNumber as format } from './numberFormat';

/**
 * Pluralize a word based on the count.
 * @example
 * pluralize(1, 'item') // '1 item'
 * pluralize(2, 'item') // '2 items'
 * pluralize(0, 'item') // '0 items'
 * pluralize(1, 'item', true) // '1 Item'
 * pluralize(2, 'item', true) // '2 Items'
 * pluralize(0, 'item', true) // '0 Items'
 */
export const pluralize = (
  count: number,
  word: string,
  firstLetterUppercase: boolean = false,
  formatNumber: boolean = false
) => {
  const firstLetter = firstLetterUppercase ? word[0].toUpperCase() : word[0];
  return `${formatNumber ? format(count) : count} ${
    firstLetter + word.slice(1)
  }${count !== 1 ? 's' : ''}`;
};
